import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

// function* close(action) {
//     const { auditId } = action.payload;
//     try {
//         const { data } = yield call(
//             http.authorized.post,
//             config.api.paths.auditClose,
//             { audit: auditId }
//         );
//         yield put(actionCreators.closeSuccess(data));
//     } catch (error) {
//         yield put(actionCreators.closeFailure(error));
//     }
// }

function* get(action) {
    try {
        const { status, page, pageSize, search, auditReference } =
            action.payload;
        const { id } = yield select((state) => state.userOrganisations.item);
        let url =
            auditReference && auditReference.length > 0
                ? `${
                      config.api.paths.auditsList
                  }?${`organisation=${id}&tab=${status}`}&page=${page}&page_size=${pageSize}&audit_reference=${auditReference}`
                : `${
                      config.api.paths.auditsList
                  }?${`organisation=${id}&tab=${status}`}&page=${page}&page_size=${pageSize}&search=${search}`;

        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On audits list get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

// function* patch(action) {
//     const { audit } = action.payload;
//     const url = `${config.api.paths.audits}${audit.id}/`;
//     try {
//         const { data } = yield call(http.authorized.patch, url, audit);
//         yield put(actionCreators.patchSuccess(data));
//     } catch (error) {
//         console.error(error);
//         yield put(actionCreators.patchFailure(error));
//     }
// }
// function* post(action) {
//     const { audits } = action.payload;
//     try {
//         const { data } = yield call(
//             http.authorized.post,
//             config.api.paths.audits,
//             audits
//         );
//         yield put(actionCreators.postSuccess(data));
//     } catch (error) {
//         console.error(error);
//         yield put(actionCreators.postFailure(error));
//     }
// }

export default function* () {
    yield all([
        // takeLatest(actionTypes.AUDIT_CLOSE_REQUEST, close),
        takeLatest(actionTypes.AUDITS_LIST_GET_REQUEST, get)
        // takeLatest(actionTypes.AUDIT_PATCH_REQUEST, patch),
        // takeLatest(actionTypes.AUDITS_LSIT_POST_REQUEST, post)
    ]);
}
